export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-sound-7e7f9c19a35f8f93c31d5fc99cd9082f.svg";